import { AMLBusinessPartnersTypes } from '../types';

import cn from '../styles.module.css';

const BusinessPartners = ({
  businessPartners,
  baseCurrency,
  clientScheme,
  monthlyTurnoverCorporate,
}: AMLBusinessPartnersTypes) => (
  <>
    <div className={cn.businessPartners}>
      <div className={cn.businessPartnersTitle}>
        {clientScheme?.suppliersTitle || 'Suppliers'}
      </div>
      <div className={cn.businessPartnersList}>
        {businessPartners?.suppliers &&
          businessPartners?.suppliers.length > 0 && (
            <>
              <div
                className={`${cn.businessPartnersRow} ${cn.businessPartnersRowHead}`}
              >
                <div className={cn.businessPartnersRowItem}>Name</div>
                <div className={cn.businessPartnersRowItem}>Volume</div>
              </div>
              {businessPartners?.suppliers?.map((item) => {
                const currentTurnover = monthlyTurnoverCorporate?.find(
                  (turnover) => turnover.value === item.monthlyTurnoverRangeId,
                );

                return (
                  <div className={cn.businessPartnersRow} key={item.id}>
                    <div className={cn.businessPartnersRowItem}>
                      {item.name}
                    </div>
                    <div className={cn.businessPartnersRowItem}>
                      {`${currentTurnover?.name} ${baseCurrency}`}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        {!businessPartners?.suppliers?.length && (
          <div className={cn.emptySuppliers}>
            No {clientScheme?.suppliersNameTitle || 'supplier'} yet
          </div>
        )}
      </div>
    </div>
    <div className={cn.businessPartners}>
      <div className={cn.businessPartnersTitle}>
        {clientScheme?.customersTitle || 'Customers'}
      </div>
      <div className={cn.businessPartnersList}>
        {businessPartners?.customers &&
          businessPartners.customers?.length > 0 && (
            <>
              <div
                className={`${cn.businessPartnersRow} ${cn.businessPartnersRowHead}`}
              >
                <div className={cn.businessPartnersRowItem}>Name</div>
                <div className={cn.businessPartnersRowItem}>Volume</div>
              </div>
              {businessPartners?.customers?.map((item) => {
                const currentTurnover = monthlyTurnoverCorporate?.find(
                  (turnover) => turnover.value === item.monthlyTurnoverRangeId,
                );

                return (
                  <div className={cn.businessPartnersRow} key={item.id}>
                    <div className={cn.businessPartnersRowItem}>
                      {item.name}
                    </div>
                    <div className={cn.businessPartnersRowItem}>
                      {`${currentTurnover?.name} ${baseCurrency}`}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        {!businessPartners?.customers?.length && (
          <div className={cn.emptyCustomers}>
            No {clientScheme?.customersNameTitle || 'customer'} yet
          </div>
        )}
      </div>
    </div>
  </>
);

export default BusinessPartners;
